import React from 'react'
import root from '../shared/utils'
import moment from 'moment'
import {fetchInvoice} from '../api'

export default React.createClass({
	getInitialState: function() {
		return {
			customerName: "",
			billingAddress: "",
			taskId: "",
			paymentMethod: "",
			lineItems: [],
			invoiceData: null,
			propertyAddress: ""
		}
	},
	componentDidMount: function() {
		fetchInvoice(this.props.params.invoiceId).then((data) => {
			this.setState({lineItems: data.lineItemInstancePojos,
				invoiceData: data.invoiceData,
				propertyAddress: data.propertyAddress,
				taskId: data.invoiceData.taskId,
				customerName: data.invoiceData.customerFullName,
				billingAddress: data.billingAddress,
				paymentMethod: data.paymentMethod})
		})
	},
	printInvoice: function() {
		window.print()
	},
	render: function() {
		let payDate = "", serviceText = "", costClass = ""
		if (this.state.invoiceData) {
			console.log(this.state.invoiceData);
			payDate = this.state.invoiceData.date.split(" ")[0]

	        if (this.state.invoiceData.type === "DEPOSIT") {
		        serviceText = this.state.invoiceData.status === "RefundSent" ? '<img src="/common/latest/images/consumer/icon_refund.png"> <b class="brand-primary-color" style="vertical-align: middle;">REFUND</b>' : '<img src="/common/latest/images/consumer/icon_deposit.png" style="height: 30px"> <b>DEPOSIT</b>'
		        costClass = this.state.invoiceData.status === "RefundSent" ? ' brand-primary-color italic' : ""
	        } else {
	            serviceText = this.state.invoiceData.serviceDate === 0 ? "" : `<b class="visible-xs-block">Service Date:&nbsp;</b>${moment(this.state.invoiceData.serviceDate).format('M/D/Y')}`
	        }
		}
		console.log("Line Items", this.state.lineItems)
		let lineItems = this.state.lineItems.filter((lineItem) => lineItem.customerVisible === true && Math.abs(lineItem.cost) > 0)
			.map((lineItem, idx) => {
				let cost = lineItem.cost < 0 ? "-$" + Math.abs(lineItem.cost).toFixed(2) : "$" + lineItem.cost.toFixed(2)
				let description = lineItem.lineItemDescription
				if (lineItem.type === "Coupon") {
					description = `<img src="/common/latest/images/consumer/icon_coupon.png"> ${lineItem.lineItemDescriptionWithoutTypePrefix}`
				}
				return (
					<tr key={idx}>
						<td>{payDate}</td>
						<td dangerouslySetInnerHTML={{__html:description}} />
						<td>{this.state.propertyAddress}</td>
						<td dangerouslySetInnerHTML={{__html:serviceText}} />
						<td className={"text-right" + costClass}>{cost}</td>
					</tr>)
			})

		let totalRows = []
		if (this.state.invoiceData) {
			if (this.state.invoiceData.salesTax) {
				let cost = this.state.invoiceData.salesTax < 0 ? "-$" + Math.abs(this.state.invoiceData.salesTax).toFixed(2) : "$" + this.state.invoiceData.salesTax.toFixed(2)
				totalRows.push(<tr key={"salesTax"}>
					<td colSpan={4}>Sales Tax</td>
					<td className="text-right">{cost}</td>
				</tr>)
			}
			totalRows.push(<tr key={"totalPaid"} className="bold">
					<td colSpan={4}>Total</td>
					<td className="text-right">${this.state.invoiceData.amount.toFixed(2)}</td>
				</tr>)
		}
		return(
			<div className="container pull-down-xs-2">
				<div className="row">
					<div className="col-sm-6">
						<img role="presentation" src={root + '/common/latest/images/TaskEasyLogo.svg'} />
					</div>
					<div className="col-sm-6">
						<div className="text-right">
							TaskEasy<br/>101 Crawfords Corner Road, Suite 2511<br/>Holmdel, NJ 07733
						</div>
					</div>
				</div>
				<div className="row pull-down-xs-2">
					<div className="col-sm-6">
						<div>
							{this.state.customerName}<br/>{this.state.billingAddress}
						</div>
						<div className="pull-down-xs-2">
							Task # {this.state.taskId}
						</div>
					</div>
				</div>
				<div className="row pull-down-xs-1">
					<div className="col-xs-12">
						<table className="table table-striped" style={{"border":"1px solid gray"}}>
							<thead>
								<tr>
									<th>Date</th>
									<th>Description</th>
									<th>Property Address</th>
									<th>Service Date</th>
									<th className="text-right">Amount</th>
								</tr>
							</thead>
							<tbody>
								{lineItems}
							</tbody>
							<tfoot>
								{totalRows}
							</tfoot>
						</table>
					</div>
				</div>
				<div className="row pull-down-xs-2">
					<div className="col-xs-12">
						Card Number: **** **** **** {this.state.paymentMethod}
					</div>
				</div>
				<div className="row pull-down-xs-2">
					<div className="col-xs-12">
						<button className="btn btn-info pull-right hidden-print" onClick={this.printInvoice}>Print</button>
					</div>
				</div>
			</div>
		)
	}
})



// WEBPACK FOOTER //
// ./src/components/billing/invoice.jsx